import { useState } from "react";
import { useEnvTemplates } from "../../api/queries";
import type { EnvTemplate } from "../../api/types";
import { Pill } from "../../components/Pill";
import { ErrorBox, Spinner } from "../../components/Spinner";
import { BACKEND_LABEL, EnvTemplateForm } from "./EnvTemplateForm";

/** e.g. "Windows · AWS EC2 instance · m6i.xlarge · ami-0abc…" */
function templateSummary(t: EnvTemplate): string {
  const c = t.config;
  const parts = [t.os === "windows" ? "Windows" : "Linux", BACKEND_LABEL[t.backend]];
  for (const k of ["instance_type", "ami_id", "image"]) if (typeof c[k] === "string") parts.push(c[k] as string);
  return parts.join(" · ");
}

export function EnvTemplateSettings({ pid }: { pid: string }) {
  const { data, isLoading, error } = useEnvTemplates(pid);
  const [editing, setEditing] = useState<EnvTemplate | "new" | null>(null);
  if (isLoading) return <Spinner />;
  if (error) return <ErrorBox error={error} />;
  return (
    <div>
      <p className="muted">
        Templates define where a task's environment runs and how it is set up. Tasks use the default template unless
        another is chosen.
      </p>
      <div className="list">
        {data?.map((t) =>
          editing !== "new" && editing?.id === t.id ? (
            <EnvTemplateForm key={t.id} pid={pid} initial={t} onDone={() => setEditing(null)} />
          ) : (
            <div key={t.id} className="list-row">
              <div className="list-main">
                <strong>{t.name}</strong> {t.is_default && <Pill color="blue">default</Pill>}
                <div className="muted small">{templateSummary(t)}</div>
              </div>
              <button className="btn btn-sm" onClick={() => setEditing(t)}>
                Edit
              </button>
            </div>
          ),
        )}
        {data?.length === 0 && <p className="muted">No templates yet.</p>}
      </div>
      {editing === "new" ? (
        <EnvTemplateForm pid={pid} onDone={() => setEditing(null)} />
      ) : (
        <button className="btn" onClick={() => setEditing("new")}>
          New template
        </button>
      )}
    </div>
  );
}
